module.exports = __webpack_public_path__ + "img/PrivacyPolicy_Collapsed_Small_Button-white.84a3c10d.svg";